<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Gateways</h1>
                <v-btn v-if="user.type === 'admin'" color="black" prepend-icon="mdi-plus"
                       @click="createDialogSwitch = true">Add
                </v-btn>
                <v-btn v-else color="black" prepend-icon="mdi-plus" @click="assignDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th v-if="user.type === 'admin'">Company</th>
                        <th>Type</th>
                        <th>Serial Number</th>
                        <th>ETH Mac</th>
                        <th>Wifi Mac</th>
                        <th>Cellular Imei</th>
                        <th>Cellular Sim1 Iccid</th>
                        <th>Cellular Sim2 Iccid</th>
                        <th>Created at</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(gateway, index) in gateways" v-if="!loading && gateways.length" :key="index"
                        class="text-left">
                        <td v-if="user.type === 'admin'">{{ gateway?.company?.company_name }}</td>
                        <td>{{ gatewayTypes[gateway?.type] }}</td>
                        <td>{{ gateway?.serial_number }}</td>
                        <td>{{ gateway?.eth_mac }}</td>
                        <td>{{ gateway?.wifi_mac }}</td>
                        <td>{{ gateway?.cellular_imei }}</td>
                        <td>{{ gateway?.cellular_sim1_iccid }}</td>
                        <td>{{ gateway?.cellular_sim2_iccid2 }}</td>
                        <td>{{ formatDateTime(gateway?.created_at) }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editGateway(gateway)">Edit
                                </v-btn>
                                <v-btn v-if="user.type === 'admin'" class="text-error" prepend-icon="mdi-delete"
                                       size="x-small" @click="deleteGateway(gateway)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="9">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="9">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination v-model="currentPage" :length="totalPages" class="my-4" density="compact"
                                  @click="fetchGateways"></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create-Gateway v-if="createDialogSwitch" v-model="createDialogSwitch" @addGateway="addGateway"/>
    <Edit-Gateway v-if="editDialogSwitch" v-model="editDialogSwitch" :gateway="selectedGateway"
                  @updateGateway="updateGateway"/>
    <Assign-Gateway v-if="user.type !== 'admin' && assignDialogSwitch" v-model="assignDialogSwitch"
                    @addGateway="addGateway"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {formatDateTime} from '@/composables/useTimezone';
import EditGateway from "@/components/dialogs/gateways/Edit.vue";
import AssignGateway from "@/components/dialogs/gateways/Assign.vue";
import CreateGateway from "@/components/dialogs/gateways/Create.vue";

const {user} = useAuthStore();
const gateways = ref([]);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const {showSnackbar} = useSnackbarStore();
const createDialogSwitch = ref(false);
const assignDialogSwitch = ref(false);
const editDialogSwitch = ref(false);
const selectedGateway = ref(null);
const gatewayTypes = {
    1: "LORA",
    2: "BLE to WIFI",
    3: "BLE to Cellular",
    4: "WIFI to Cellular",
};

onMounted(() => {
    fetchGateways();
});

const fetchGateways = () => {
    loading.value = true;
    send('get', `gateways?page=${currentPage.value}`)
        .then((response) => {
            gateways.value = response.data.data.data;
            totalPages.value = response.data.last_page;
            currentPage.value = response.data.current_page;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Gateways could not be loaded', 'error')
        })
}
const addGateway = (gateway) => {
    gateways.value.unshift(gateway);
}
const editGateway = (gateway) => {
    selectedGateway.value = gateway;
    editDialogSwitch.value = true;
}
const updateGateway = (gateway) => {
    gateways.value.map((comp, index) => {
        if (comp.id === gateway.id) {
            gateways.value[index] = gateway;
        }
    });
}
const deleteGateway = (gateway) => {
    if (confirm(`Are you sure to delete "${gateway.serial_number}" gateway?`)) {
        send('delete', `gateways/${gateway.id}`)
            .then((response) => {
                if (response.data.success) {
                    gateways.value.map((comp, index) => {
                        if (comp.id === gateway.id) {
                            gateways.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error)
                showSnackbar(`"${gateway.first_name}"Gateway could not be deleted`, 'error')
            })
    }
}
</script>

<style scoped>
</style>
